<template>
  <ContactUsComponent
    :is-visible="showContactModal"
    @close="closeContactModal"
  />
  <div class="wrapper-corporate">
    <MenuComponent
      logoUrl="assets/logos/LogoLightBlue.svg"
      textColor="var(--light-blue)"
      menuIcon="assets/icons/MenuLightBlue.svg"
      closeIcon="assets/icons/CloseLightBlue.svg"
    />

    <PrincipalSection
      title="FOTO Y VIDEO EMPRESARIAL"
      text="Convertimos tus procesos internos en activos que fortalecen tu producto y tu servicio"
      overlayColor="var(--light-blue)"
      layout="media-right"
      mediaType="video"
      mediaSrc="assets/corporate/InitialVideo.mp4"
      mediaAlt="Gestion redes sociales"
      buttonText="Agenda una llamada"
      buttonBackground="var(--white)"
      buttonTextColor="var(--light-blue)"
      buttonShadow="light"
      @button-click="openContactModal"
    />

    <div class="wrapper-info">
      <p class="text">
        Deja de asumir que el mercado entiende cómo trabajas; empieza a
        demostrarlo y convierte tu operación en una
      </p>
      <p class="title">VENTAJA COMPETITIVA</p>
    </div>

    <div class="container">
      <div class="wrapper-content">
        <img src="assets/corporate/Icon1.svg" alt="Que se vea" class="icon" />
        <p>Que se vea</p>
      </div>
      <div class="wrapper-content">
        <img
          src="assets/corporate/Icon2.svg"
          alt="Que se entienda"
          class="icon"
        />
        <p>Que se entienda</p>
      </div>
      <div class="wrapper-content">
        <img
          src="assets/corporate/Icon3.svg"
          alt="Respalde cada venta"
          class="icon"
        />
        <p>Respalde cada venta</p>
      </div>
    </div>

    <div class="mini-gallery">
      <img
        src="assets/corporate/Image1.png"
        alt="Imagen corporativa"
        class="image"
      />
      <img
        src="assets/corporate/Image2.png"
        alt="Imagen corporativa"
        class="image"
      />
      <img
        src="assets/corporate/Image3.png"
        alt="Imagen corporativa"
        class="image"
      />
    </div>

    <FooterComponent overlayColor="var(--light-blue)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import PrincipalSection from "../layout/components/PrincipalSection.vue";
import ContactUsComponent from "../sharedComponents/ContactUsComponent.vue";
import { contactUsUse } from "../sharedComponents/use/contactUsUse";

export default {
  name: "CorporateView",
  components: {
    MenuComponent,
    FooterComponent,
    PrincipalSection,
    ContactUsComponent,
  },

  setup() {
    const { showContactModal, openContactModal, closeContactModal } =
      contactUsUse();

    return {
      showContactModal,
      openContactModal,
      closeContactModal,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/corporate/styles/corporateStyle";
</style>